// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.home {
  padding-bottom: 70px;
  overflow: hidden;
}

/* ── Hero ── */

.hero {
  max-width: 1080px;
  margin: 0 auto;
  padding: 36px 36px 0;
}

.hero-title {
  display: grid;
  grid-template-columns: auto 1fr auto;
  grid-template-rows: auto auto;
  align-items: center;
  position: relative;
}

.hero-jays {
  grid-column: 1;
  grid-row: 1;
  font-family: var(--font-display);
  font-size: clamp(90px, 13vw, 170px);
  color: var(--green);
  text-transform: uppercase;
  line-height: 1;
  letter-spacing: -2px;
  align-self: start;
  position: relative;
  top: -0.15em;
  margin-right: -0.4em;
  z-index: 1;
}

.hero-clock-area {
  grid-column: 2;
  grid-row: 1 / 3;
  justify-self: center;
  width: clamp(216px, 32.4vw, 456px);
  z-index: 0;
}

.hero-clock {
  position: relative;
  width: 100%;
  aspect-ratio: 2816 / 2789;
  overflow: hidden;
}

.hero-clock-face {
  width: 100%;
  height: auto;
  display: block;
  border-radius: 50%;
}

.hero-clock-hand {
  position: absolute;
  display: block;
  will-change: transform;
}

.hero-clock-hand-hours {
  width: 14.2%;
  top: -20.42%;
  left: 42.61%;
  transform-origin: 52% 84.66%;
  z-index: 2;
}

.hero-clock-hand-minutes {
  width: 13.81%;
  top: -42.11%;
  left: 44.07%;
  transform-origin: 42.93% 86.12%;
  z-index: 3;
}

.hero-clock-hand-seconds {
  width: 7.81%;
  top: -41.5%;
  left: 46.09%;
  transform-origin: 50% 70.81%;
  z-index: 4;
}

.hero-clays {
  grid-column: 3;
  grid-row: 2;
  font-family: var(--font-display);
  font-size: clamp(75px, 10vw, 135px);
  color: var(--gold);
  text-transform: uppercase;
  line-height: 1;
  letter-spacing: -2px;
  align-self: end;
  position: relative;
  bottom: -0.15em;
  margin-left: -0.55em;
  z-index: 1;
}

.hero-description {
  font-family: var(--font-body);
  font-size: clamp(14px, 1.4vw, 20px);
  color: var(--dark);
  line-height: 1.7;
  max-width: 800px;
  margin: 36px auto 0;
  text-align: left;
  padding: 0 20px;
}

/* ── Sections ── */

.home-sections {
  max-width: 1080px;
  margin: 70px auto 0;
  display: flex;
  flex-direction: column;
  gap: 22px;
  padding: 0 36px;
}

.home-section {
  display: flex;
  align-items: center;
  gap: 50px;
  transition: transform 0.3s ease;
}

a.home-section:hover {
  transform: scale(1.01);
}

.section-right {
  flex-direction: row;
  justify-content: flex-start;
}

.section-left {
  flex-direction: row;
  justify-content: flex-end;
}

.section-image-wrapper {
  width: clamp(160px, 22vw, 290px);
  flex-shrink: 0;
}

.section-image-sm {
  width: clamp(125px, 16vw, 215px);
}

.section-image-lg {
  width: clamp(200px, 27vw, 360px);
  overflow: hidden;
}

.section-image-wrapper img {
  width: 100%;
  height: auto;
  display: block;
  border-radius: 7px;
}

.section-image-wrapper.rotate-left {
  transform: rotate(-11deg);
  transition: transform 0.4s ease;
}

.section-image-wrapper.rotate-right {
  transform: rotate(8deg);
  transition: transform 0.4s ease;
}

.section-image-wrapper:not(.rotate-left):not(.rotate-right) {
  transition: transform 0.4s ease;
}

.home-section:hover .rotate-left {
  transform: rotate(-17deg);
}

.home-section:hover .rotate-right {
  transform: rotate(14deg);
}

.home-section:hover .section-image-wrapper:not(.rotate-left):not(.rotate-right) {
  transform: rotate(-6deg);
}

.section-title {
  font-family: var(--font-body);
  font-size: clamp(22px, 2.7vw, 32px);
  font-weight: 700;
  color: var(--dark);
}

@media (max-width: 768px) {
  .hero {
    padding: 18px 18px 0;
  }

  .hero-title {
    display: block;
    position: relative;
    width: fit-content;
    margin: 0 auto;
  }

  .hero-jays {
    position: absolute;
    top: -0.35em;
    left: -1em;
    font-size: clamp(52px, 14vw, 72px);
    z-index: 1;
    margin-right: 0;
  }

  .hero-clock-area {
    display: block;
    width: clamp(200px, 55vw, 260px);
    margin: 0 auto;
  }

  .hero-clays {
    position: absolute;
    bottom: -0.5em;
    right: -1.2em;
    font-size: clamp(52px, 14vw, 72px);
    z-index: 1;
    margin-left: 0;
  }

  .hero-description {
    font-size: 14px;
    margin-top: 50px;
    padding: 0;
  }

  .home-sections {
    padding: 0 18px;
    gap: 36px;
    margin-top: 54px;
  }

  .home-section {
    flex-direction: row !important;
    text-align: left;
    gap: 16px;
    align-items: center;
  }

  .section-right {
    flex-direction: row !important;
  }

  .section-left {
    flex-direction: row !important;
    text-align: left;
  }

  .section-image-wrapper {
    width: 120px;
  }

  .section-title {
    font-size: 20px;
  }

  .section-image-wrapper.rotate-left,
  .section-image-wrapper.rotate-right {
    transform: rotate(0);
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Home.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA,eAAe;;AAEf;EACE,iBAAiB;EACjB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,6BAA6B;EAC7B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,gCAAgC;EAChC,mCAAmC;EACnC,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,oBAAoB;EACpB,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,kCAAkC;EAClC,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,4BAA4B;EAC5B,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,+BAA+B;EAC/B,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,4BAA4B;EAC5B,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,WAAW;EACX,gCAAgC;EAChC,mCAAmC;EACnC,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,6BAA6B;EAC7B,mCAAmC;EACnC,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;;AAEA,mBAAmB;;AAEnB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;EACE,uBAAuB;EACvB,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,6BAA6B;EAC7B,mCAAmC;EACnC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,UAAU;IACV,kCAAkC;IAClC,UAAU;IACV,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,gCAAgC;IAChC,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,aAAa;IACb,kCAAkC;IAClC,UAAU;IACV,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,UAAU;EACZ;;EAEA;IACE,eAAe;IACf,SAAS;IACT,gBAAgB;EAClB;;EAEA;IACE,8BAA8B;IAC9B,gBAAgB;IAChB,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,8BAA8B;IAC9B,gBAAgB;EAClB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,oBAAoB;EACtB;AACF","sourcesContent":[".home {\n  padding-bottom: 70px;\n  overflow: hidden;\n}\n\n/* ── Hero ── */\n\n.hero {\n  max-width: 1080px;\n  margin: 0 auto;\n  padding: 36px 36px 0;\n}\n\n.hero-title {\n  display: grid;\n  grid-template-columns: auto 1fr auto;\n  grid-template-rows: auto auto;\n  align-items: center;\n  position: relative;\n}\n\n.hero-jays {\n  grid-column: 1;\n  grid-row: 1;\n  font-family: var(--font-display);\n  font-size: clamp(90px, 13vw, 170px);\n  color: var(--green);\n  text-transform: uppercase;\n  line-height: 1;\n  letter-spacing: -2px;\n  align-self: start;\n  position: relative;\n  top: -0.15em;\n  margin-right: -0.4em;\n  z-index: 1;\n}\n\n.hero-clock-area {\n  grid-column: 2;\n  grid-row: 1 / 3;\n  justify-self: center;\n  width: clamp(216px, 32.4vw, 456px);\n  z-index: 0;\n}\n\n.hero-clock {\n  position: relative;\n  width: 100%;\n  aspect-ratio: 2816 / 2789;\n  overflow: hidden;\n}\n\n.hero-clock-face {\n  width: 100%;\n  height: auto;\n  display: block;\n  border-radius: 50%;\n}\n\n.hero-clock-hand {\n  position: absolute;\n  display: block;\n  will-change: transform;\n}\n\n.hero-clock-hand-hours {\n  width: 14.2%;\n  top: -20.42%;\n  left: 42.61%;\n  transform-origin: 52% 84.66%;\n  z-index: 2;\n}\n\n.hero-clock-hand-minutes {\n  width: 13.81%;\n  top: -42.11%;\n  left: 44.07%;\n  transform-origin: 42.93% 86.12%;\n  z-index: 3;\n}\n\n.hero-clock-hand-seconds {\n  width: 7.81%;\n  top: -41.5%;\n  left: 46.09%;\n  transform-origin: 50% 70.81%;\n  z-index: 4;\n}\n\n.hero-clays {\n  grid-column: 3;\n  grid-row: 2;\n  font-family: var(--font-display);\n  font-size: clamp(75px, 10vw, 135px);\n  color: var(--gold);\n  text-transform: uppercase;\n  line-height: 1;\n  letter-spacing: -2px;\n  align-self: end;\n  position: relative;\n  bottom: -0.15em;\n  margin-left: -0.55em;\n  z-index: 1;\n}\n\n.hero-description {\n  font-family: var(--font-body);\n  font-size: clamp(14px, 1.4vw, 20px);\n  color: var(--dark);\n  line-height: 1.7;\n  max-width: 800px;\n  margin: 36px auto 0;\n  text-align: left;\n  padding: 0 20px;\n}\n\n/* ── Sections ── */\n\n.home-sections {\n  max-width: 1080px;\n  margin: 70px auto 0;\n  display: flex;\n  flex-direction: column;\n  gap: 22px;\n  padding: 0 36px;\n}\n\n.home-section {\n  display: flex;\n  align-items: center;\n  gap: 50px;\n  transition: transform 0.3s ease;\n}\n\na.home-section:hover {\n  transform: scale(1.01);\n}\n\n.section-right {\n  flex-direction: row;\n  justify-content: flex-start;\n}\n\n.section-left {\n  flex-direction: row;\n  justify-content: flex-end;\n}\n\n.section-image-wrapper {\n  width: clamp(160px, 22vw, 290px);\n  flex-shrink: 0;\n}\n\n.section-image-sm {\n  width: clamp(125px, 16vw, 215px);\n}\n\n.section-image-lg {\n  width: clamp(200px, 27vw, 360px);\n  overflow: hidden;\n}\n\n.section-image-wrapper img {\n  width: 100%;\n  height: auto;\n  display: block;\n  border-radius: 7px;\n}\n\n.section-image-wrapper.rotate-left {\n  transform: rotate(-11deg);\n  transition: transform 0.4s ease;\n}\n\n.section-image-wrapper.rotate-right {\n  transform: rotate(8deg);\n  transition: transform 0.4s ease;\n}\n\n.section-image-wrapper:not(.rotate-left):not(.rotate-right) {\n  transition: transform 0.4s ease;\n}\n\n.home-section:hover .rotate-left {\n  transform: rotate(-17deg);\n}\n\n.home-section:hover .rotate-right {\n  transform: rotate(14deg);\n}\n\n.home-section:hover .section-image-wrapper:not(.rotate-left):not(.rotate-right) {\n  transform: rotate(-6deg);\n}\n\n.section-title {\n  font-family: var(--font-body);\n  font-size: clamp(22px, 2.7vw, 32px);\n  font-weight: 700;\n  color: var(--dark);\n}\n\n@media (max-width: 768px) {\n  .hero {\n    padding: 18px 18px 0;\n  }\n\n  .hero-title {\n    display: block;\n    position: relative;\n    width: fit-content;\n    margin: 0 auto;\n  }\n\n  .hero-jays {\n    position: absolute;\n    top: -0.35em;\n    left: -1em;\n    font-size: clamp(52px, 14vw, 72px);\n    z-index: 1;\n    margin-right: 0;\n  }\n\n  .hero-clock-area {\n    display: block;\n    width: clamp(200px, 55vw, 260px);\n    margin: 0 auto;\n  }\n\n  .hero-clays {\n    position: absolute;\n    bottom: -0.5em;\n    right: -1.2em;\n    font-size: clamp(52px, 14vw, 72px);\n    z-index: 1;\n    margin-left: 0;\n  }\n\n  .hero-description {\n    font-size: 14px;\n    margin-top: 50px;\n    padding: 0;\n  }\n\n  .home-sections {\n    padding: 0 18px;\n    gap: 36px;\n    margin-top: 54px;\n  }\n\n  .home-section {\n    flex-direction: row !important;\n    text-align: left;\n    gap: 16px;\n    align-items: center;\n  }\n\n  .section-right {\n    flex-direction: row !important;\n  }\n\n  .section-left {\n    flex-direction: row !important;\n    text-align: left;\n  }\n\n  .section-image-wrapper {\n    width: 120px;\n  }\n\n  .section-title {\n    font-size: 20px;\n  }\n\n  .section-image-wrapper.rotate-left,\n  .section-image-wrapper.rotate-right {\n    transform: rotate(0);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
